import * as Yup from 'yup'; 
import { firstLetterCapitalized, onlyChars, personalIdParser } from 'components/Form/Helpers/Parsers'
import { AutocompleteValues, FieldTypes, IFields, InputModes } from 'models/Form/FieldsModels'
import { isPostalCodeValid } from 'components/Form/Validations/PostalCodeValidation'
import { isPeselValid } from 'components/Form/Validations/PeselValidation'
import { hasPersonalIdNumberCorrectFormat } from 'components/Form/Validations/PersonalIdNumberValidation'
import { isDateValid, isPersonalIdReleaseCorrect } from 'components/Form/Validations/DateValidation'

export enum ExtendedInfoFieldsNames {
   Pesel = 'Pesel',
   PersonalId = 'PersonalId',
   PersonalIdRelease = 'PersonalIdRelease',
}

export const extendedInfoFields: IFields = {
   [ExtendedInfoFieldsNames.Pesel]: {
      order: 0,
      name: ExtendedInfoFieldsNames.Pesel,
      type: FieldTypes.string,
      label: "Nr PESEL",
      placeholder: "Podaj 11 cyfrowy nr PESEL",
      inputMode: InputModes.numeric,
      browserAutocomplete: AutocompleteValues.Off,

      visible: true,
      mask: "99999999999",
      validation: Yup.string().required('Nieprawidłowa wartość').test(isPeselValid),
   },
   [ExtendedInfoFieldsNames.PersonalId]: {
      order: 5,
      name: ExtendedInfoFieldsNames.PersonalId,
      type: FieldTypes.string,
      label: "Numer Dowodu",
      placeholder: "Składa się z trzech liter i sześciu cyfr",
      inputMode: InputModes.text,
      browserAutocomplete: AutocompleteValues.Off,

      visible: true,
      mask: 'aaa999999',
      parser: personalIdParser,
      validation: Yup.string().required("Niepoprawna wartość").test(hasPersonalIdNumberCorrectFormat)
   },
   [ExtendedInfoFieldsNames.PersonalIdRelease]: {
      order: 10,
      name: ExtendedInfoFieldsNames.PersonalIdRelease,
      type: FieldTypes.date,
      label: "Data wydania",
      placeholder: "Data wydania dowodu osobistego",
      inputMode: InputModes.numeric,
      browserAutocomplete: AutocompleteValues.Off,

      visible: true,
      validation: Yup.string().required("Nieprawidłowa wartość").test(isDateValid).test(isPersonalIdReleaseCorrect)
   },
}